import { Button, Text } from '@chakra-ui/react'
import type { PublicJoinResponse } from '@ipc/shared'
import { Outlet, useParams } from 'react-router'
import { useJoinInfo } from '~/api/hooks'
import { ErrorAlert, useFriendlyError } from '~/components/member/feedback'
import { MemberLayout } from '~/components/member/layout'
import { StepSkeleton } from '~/components/member/StepSkeleton'
import { useT } from '~/i18n/use-t'
import LinkNotActive from './LinkNotActive'

export interface JoinContext {
  join: PublicJoinResponse
}

/**
 * Gate of the pages that start a registration (S0 and S1): a link whose provider is turned off, not approved or
 * unknown shows "This registration link is not active" and points to the default link. The later steps do not go
 * through this gate: a registration under way continues with its provider.
 */
export default function JoinRoute() {
  const { providerId } = useParams()
  const { t } = useT()
  const friendly = useFriendlyError()
  const q = useJoinInfo(providerId)
  if (q.isPending)
    return (
      <MemberLayout>
        <StepSkeleton />
      </MemberLayout>
    )
  if (q.isError)
    return (
      <MemberLayout>
        <ErrorAlert>{friendly(q.error)}</ErrorAlert>
        <Button alignSelf='flex-start' onClick={() => void q.refetch()}>
          {t('common.tryAgain')}
        </Button>
      </MemberLayout>
    )
  if (!q.data.active) return <LinkNotActive defaultJoinPath={q.data.defaultJoinPath} />
  return <Outlet context={{ join: q.data } satisfies JoinContext} />
}
